import { FC, ReactElement } from 'react'

import { FLOATING_PANE_CRYPTO_REWARDS_BUY_MODE, FLOATING_PANE_CRYPTO_REWARDS_SELL_MODE } from 'components/features/rewards/rewardsPane/constants/paneState'

import styles from 'components/features/rewards/rewardsPane/components/CryptoRewardsOrderType/CryptoRewardsOrderType.styl'

type CryptoRewardsOrderTypeProps = {
  orderType: typeof FLOATING_PANE_CRYPTO_REWARDS_BUY_MODE | typeof FLOATING_PANE_CRYPTO_REWARDS_SELL_MODE
}

export const CryptoRewardsOrderType: FC<CryptoRewardsOrderTypeProps> = ({
  orderType,
}): ReactElement => {
  const name = orderType === FLOATING_PANE_CRYPTO_REWARDS_BUY_MODE
    ? 'Limit Buy'
    : 'Limit Sell'

  return (
    <span className={ styles.label }>
      { name }
    </span>
  )
}
